import { buildFacet, buildTab, SearchEngine, Tab } from "@coveo/headless";
import { FacetSortCriterion } from "@coveo/headless/dist/definitions/features/facets/facet-set/interfaces/request";
import {
	CoveoHeadlessFacetName,
	CoveoHeadlessTab,
} from "components/coveo-headless/types/coveo-headless-types";

export const generateTabs = (engine: SearchEngine, headlessTabs: CoveoHeadlessTab) => {
	const keys = Object.keys(headlessTabs);
	const tab: { [key: string]: Tab } = {};
	for (const key of keys) {
		tab[key] = buildTab(engine, {
			initialState: { isActive: headlessTabs[key].isActive },
			options: {
				id: `${key}`,
				expression: headlessTabs[key].tabFacet,
			},
		});
	}
	return tab;
};

export const generateFacets = (
	engine: SearchEngine,
	facetName: CoveoHeadlessFacetName[],
	facetSortCriteria = "alphanumeric" as FacetSortCriterion,
	numberOfFacetsToShow = 12
) => {
	let facets = facetName.map((filter) => {
		const { facetField } = filter;
		return buildFacet(engine, {
			options: {
				field: facetField,
				facetId: facetField,
				sortCriteria: facetSortCriteria,
				numberOfValues: numberOfFacetsToShow,
			},
		});
	});
	return facets;
};
